import store from "@/store";

export default {
	data() {
		return {
			sensorList: [
				{ id: '6120084', location: 'TPI Sales Window' },
				{ id: '6119791', location: 'Trading window (fred)' },
				{ id: '6119765', location: 'IT/CF window' },
				{ id: '6119813', location: 'Praxis window' },
				{ id: '6120042', location: 'Guest kitchen' },
				{ id: '6119920', location: 'Reception' },
				{ id: '6119729', location: 'Ops rear centre' },
				{ id: '6120127', location: 'Direct sales printer 2' },
				{ id: '6119801', location: 'Finance centre' },
				{ id: '6119939', location: 'Main kitchen' },
				{ id: '6119806', location: 'Meeting room 5' },
				{ id: '6119818', location: 'Ops rear window' },
				{ id: '6120093', location: 'Direct sales window' },
				{ id: '6120094', location: 'Finance window' },
				{ id: '6119795', location: 'Meeting room 4' },
				{ id: '6120085', location: 'Meeting room 3' },
				{ id: '6119798', location: 'Meeting room 2' },
				{ id: '6119815', location: 'Meeting room 1' }
			],
			overallFields: [
				'D6F00034F12A8_CT22',
				'D6F00034F12A8_CT23',
				'D6F00034F12A8_CT24'
			],
			lightFields: [
				'D6F00034F12A8_CT25',
				'D6F00034F12A8_CT26',
				'D6F00034F12A8_CT27',
				'D6F00034F12A8_CT28',
				'D6F00034F12A8_CT29',
				'D6F00034F12A8_CT30',
				'D6F00034F12A8_CT31',
				'D6F00034F12A8_CT32',
				'D6F00034F12A8_CT33'
			],
			kitchenFields: [
				'D6F00034F12A8_CT1',
				'D6F00034F12A8_CT4',
			],
			mbportFields: [
				'D6F00034F12A8_CT5',
				'D6F00034F12A8_CT8',
				'D6F00034F12A8_CT9',
				'D6F00034F12A8_CT10',
				'D6F00034F12A8_CT11',
				'D6F00034F12A8_CT12'
			],
			electrakFields: [
				'D6F00034F12A8_CT13',
				'D6F00034F12A8_CT14',
				'D6F00034F12A8_CT15',
				'D6F00034F12A8_CT16',
				'D6F00034F12A8_CT17'
			],
			acFields: [
				'D6F00034F12A8_CT18'
			],
			lineChartFields: [
				{ useDevice: true, field: 'D6F00034F12A8_CT1', label: 'Kitchen 2' },
				{ useDevice: true, field: 'D6F00034F12A8_CT3', label: 'Kitchen 1' },
				{ useDevice: true, field: 'D6F00034F12A8_CT5', label: 'MDB Port 2' },
				{ useDevice: true, field: 'D6F00034F12A8_CT8', label: 'MB1 Port 5' },
				{ useDevice: true, field: 'D6F00034F12A8_CT9', label: 'MB1 Port 6' },
				{ useDevice: true, field: 'D6F00034F12A8_CT10', label: 'MB2 Port 1' },
				{ useDevice: true, field: 'D6F00034F12A8_CT11', label: 'MB2 Port 2' },
				{ useDevice: true, field: 'D6F00034F12A8_CT12', label: 'MB2 Port 3' },
				{ useDevice: true, field: 'D6F00034F12A8_CT13', label: 'ELECTRAK 1' },
				{ useDevice: true, field: 'D6F00034F12A8_CT14', label: 'ELECTRAK 2' },
				{ useDevice: true, field: 'D6F00034F12A8_CT15', label: 'ELECTRAK 3' },
				{ useDevice: true, field: 'D6F00034F12A8_CT16', label: 'ELECTRAK 4' },
				{ useDevice: true, field: 'D6F00034F12A8_CT17', label: 'ELECTRAK 5' },
				{ useDevice: true, field: 'D6F00034F12A8_CT18', label: 'A/C Roof Comms Room' },
				{ useDevice: true, field: 'D6F00034F12A8_CT22', label: 'Main Incomer Brown' },
				{ useDevice: true, field: 'D6F00034F12A8_CT23', label: 'Main Incomer Black' },
				{ useDevice: true, field: 'D6F00034F12A8_CT24', label: 'Main Incomer Grey' },
				{ useDevice: true, field: 'D6F00034F12A8_CT25', label: 'LCM 412 & 411' },
				{ useDevice: true, field: 'D6F00034F12A8_CT26', label: 'LCM 40E & 40D' },
				{ useDevice: true, field: 'D6F00034F12A8_CT27', label: 'LCM 400 & 40F' },
				{ useDevice: true, field: 'D6F00034F12A8_CT28', label: 'LCM 40B & 403' },
				{ useDevice: true, field: 'D6F00034F12A8_CT29', label: 'LCM 414 & 413' },
				{ useDevice: true, field: 'D6F00034F12A8_CT30', label: 'LCM 404 & 40C' },
				{ useDevice: true, field: 'D6F00034F12A8_CT31', label: 'LCM 405 406 & 407' },
				{ useDevice: true, field: 'D6F00034F12A8_CT32', label: 'LCM 40A & 402' },
				{ useDevice: true, field: 'D6F00034F12A8_CT33', label: 'LCM 400 & 408' },
				{ useDevice: true, field: 'D6F00034F12A8_F1', label: 'Frequency 1' },
				{ useDevice: true, field: 'D6F00034F12A8_F2', label: 'Frequency 2' },
				{ useDevice: true, field: 'D6F00034F12A8_F3', label: 'Frequency 3' },
				{ useDevice: true, field: 'D6F00034F12A8_V1', label: 'Voltage 1' },
				{ useDevice: true, field: 'D6F00034F12A8_V2', label: 'Voltage 2' },
				{ useDevice: true, field: 'D6F00034F12A8_V3', label: 'Voltage 3' }
			],
		}
	},
	methods: {
		getEnvironmentQuery(time, type) {
			let query = '';
			let today = new Date();
			let start = '';
			let end = '';
			let aggreateQuery = '';
			let queryData = [];

			if (typeof time !== 'string') {
				start = new Date(time.start).toISOString().slice(0, 10) + 'T00:00:00Z';
				let _endDate = new Date(time.end);
				_endDate.setDate(_endDate.getDate() + 1);
				end = new Date(time.end).toISOString().slice(0, 10) + 'T00:00:00Z';
				aggreateQuery = 'aggregateWindow(every: 1h, fn: mean, column: "_value")';
			} else {
				switch (time) {
					case 'today':
						start = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						today.setDate(today.getDate() + 1);
						end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						aggreateQuery = 'aggregateWindow(every: 1h, fn: mean, column: "_value")';
						break;
					case 'month':
						start = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().slice(0, 10) + 'T00:00:00Z';
						end = new Date(today.getFullYear(), today.getMonth() + 1, 2).toISOString().slice(0, 10) + 'T00:00:00Z';
						aggreateQuery = 'aggregateWindow(every: 1d, fn: mean, column: "_value")';
						break;
					case 'year':
						start = new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10) + 'T00:00:00Z';
						end = new Date(today.getFullYear() + 1, 0, 2).toISOString().slice(0, 10) + 'T00:00:00Z';
						aggreateQuery = 'aggregateWindow(every: 1mo, fn: mean, column: "_value")';
						break;
				}
			}

			this.sensorList.forEach(item => {
				let field = '';
				switch (type) {
					case 'temperature':
						field = 'uplink_message_decoded_payload_averageTemperature_value';
						break;
					case 'humidity':
						field = 'uplink_message_decoded_payload_humidity_value';
						break;
					case 'light':
						field = 'uplink_message_decoded_payload_lux_value';
						break;
				}
				query = `|> range(start: ${start}, stop: ${end})
	               |> filter(fn:(r) =>  r._field == "${field}" and
	                  r.topic == "v3/bgoffice@bgpoc/devices/bgstrips-${item.id}/up")
	               |> ${aggreateQuery}`;

				queryData.push({ name: item.location, query: query });
			});

			return queryData;
		},
		getHvacQuery(time, type) {
			let query = '';
			let today = new Date();
			let start = '';
			let end = '';
			let queryData = [];

			switch (time) {
				case 'today':
					start = today.toISOString().slice(0, 10) + 'T00:00:00Z';
					end = today.toISOString();
					break;
				case 'month':
					start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString();
					end = today.toISOString();
					break;
				case 'year':
					start = new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10) + 'T00:00:00Z';
					end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
					break;
			}

			this.sensorList.forEach(item => {
				let field = '';
				switch (type) {
					case 'temperature':
						field = 'uplink_message_decoded_payload_averageTemperature_value';
						break;
					case 'humidity':
						field = 'uplink_message_decoded_payload_humidity_value';
						break;
					case 'light':
						field = 'uplink_message_decoded_payload_lux_value';
						break;
				}
				query = `|> range(start: ${start}, stop: ${end})
	               |> filter(fn:(r) =>  r._field == "${field}" and
	                  r.topic == "v3/bgoffice@bgpoc/devices/bgstrips-${item.id}/up")
	               |> mean(column: "_value")`;

				queryData.push({ name: item.location, query: query });
			});

			return queryData;
		},
		getMapPower(time) {
			let range = '';
			let today = new Date();
			let start = '';
			let end = '';
			let field = '';
			let query = '';
			let aggregateQuery = '';

			// switch (time) {
			//   case 'today':
			// 	  // start = today.toISOString().slice(0, 10) + 'T00:00:00Z';
			// 	  // end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
			// 	  let _date = new Date(today.getFullYear(), today.getMonth(), 1);
			// 	  start = _date.toISOString().slice(0, 10) + 'T00:00:00Z';
			// 	  end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
			// 	  break;
			//   case 'month':
			// 	  let date = new Date(today.getFullYear(), today.getMonth(), 1);
			// 	  start = date.toISOString().slice(0, 10) + 'T00:00:00Z';
			// 	  end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
			// 	  break;
			//   case 'year':
			// 	  // let firstDay = new Date(new Date().getFullYear(), 0, 1);
			// 	  // start = firstDay.toISOString().slice(0, 10) + 'T00:00:00Z';
			// 	  // end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
			//
			// 	  let Ddate = new Date(today.getFullYear(), today.getMonth(), 1);
			// 	  start = Ddate.toISOString().slice(0, 10) + 'T00:00:00Z';
			// 	  end = today.toISOString().slice(0, 10) + 'T23:59:59Z';
			// 	  break;
			// }

			// range = `range(start: ${start}, stop: ${end})`;

			let startDate = new Date(today.getFullYear(), today.getMonth(), 1);
			startDate.setDate(startDate.getDate() + 1);
			start = startDate.toISOString().slice(0, 10) + 'T00:00:00Z';

			let endDate = new Date(today.getFullYear(), today.getMonth() + 1, 2);
			end = endDate.toISOString().slice(0, 10) + 'T00:00:00Z';
			range = `range(start: ${start}, stop: ${end})`;

			field = `r._field == "${this.overallFields[0]}" or
               r._field == "${this.overallFields[1]}" or
               r._field == "${this.overallFields[2]}"`;

			switch (time) {
				case 'today':
					// aggregateQuery = 'aggregateWindow(every: 1h, fn: sum, column: "_value")';
					aggregateQuery = 'aggregateWindow(every: 1d, fn: sum, column: "_value")';
					break;
				case 'month':
					aggregateQuery = 'aggregateWindow(every: 1d, fn: sum, column: "_value")';
					break;
				case 'year':
					// aggregateQuery = 'aggregateWindow(every: 1mo, fn: sum, column: "_value")';
					aggregateQuery = 'aggregateWindow(every: 1d, fn: sum, column: "_value")';
					break;
			}

			query = `|> ${range}
               |> filter(fn:(r) => ${field})
               |> ${aggregateQuery}`;
			return query;
		},
		getSelectedTimeRange(time) {
			let range = '';
			let today = new Date();
			let start = '';
			let end = '';
			let viewType = '';

			if (typeof time === 'object') {
				let _date = new Date(time.start);
				_date.setDate(_date.getDate() - 1);
				start = _date.toISOString().slice(0, 10) + 'T23:00:00Z';
				let _date1 = new Date(time.end);
				_date1.setDate(_date1.getDate() + 1);
				end = _date1.toISOString().slice(0, 10) + 'T00:00:00Z';

				const days = (date_1, date_2) => {
					let difference = date_1.getTime() - date_2.getTime();
					let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
					return Math.abs(TotalDays);
				}

				const rangeDays = days(new Date(start), new Date(end));
				if (rangeDays < 3) {
					viewType = 'minute';
				}

				if (rangeDays > 2 && rangeDays < 32) {
					viewType = 'hour';
				}
				if (rangeDays > 31) {
					viewType = 'day';
				}
			} else {
				switch (time) {
					case 'last':
						today.setDate(today.getDate() - 1);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						today.setDate(today.getDate() + 2);
						end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						viewType = 'minute';
						break;
					case '6hours':
						end = today.toISOString().slice(0, 14) + '00:00Z';
						today.setHours(today.getHours() - 6);
						start = today.toISOString().slice(0, 14) + '00:00Z';
						viewType = 'minute';
						break;
					case 'day':
						today.setDate(today.getDate() - 1);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						today.setDate(today.getDate() + 2);
						end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						viewType = 'minute';
						break;
					case '2days':
						today.setDate(today.getDate() + 1);
						end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						today.setDate(today.getDate() - 3);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						viewType = 'minute';
						break;
					case 'week':
						end = today.toISOString();
						today.setDate(today.getDate() - 7);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						viewType = 'hour';
						break;
					case 'month':
						end = today.toISOString();
						today.setDate(today.getDate() - 31);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						viewType = 'hour';
						break;
					case 'year':
						end = today.toISOString();
						today.setDate(today.getDate() - 366);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						viewType = 'day';
						break;
					case 'today':
						today.setDate(today.getDate() - 1);
						start = today.toISOString().slice(0, 10) + 'T23:00:00Z';
						today.setDate(today.getDate() + 2);
						end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
						viewType = 'minute';
						break;
					case 'pMonth':
						let startDate = new Date(today.getFullYear(), today.getMonth(), 2);
						startDate.setDate(startDate.getDate() - 1);
						start = startDate.toISOString().slice(0, 10) + 'T23:00:00Z';

						let endDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
						end = endDate.toISOString().slice(0, 10) + 'T00:00:00Z';
						viewType = 'hour';
						break;
					case 'pYear':
						let fDate = new Date(today.getFullYear(), 0, 2);
						fDate.setDate(fDate.getDate() - 1);
						start = fDate.toISOString().slice(0, 10) + 'T23:00:00Z';;
						end = new Date(today.getFullYear() + 1, 0, 1).toISOString().slice(0, 10) + 'T00:00:00Z';
						viewType = 'day';
						break;
				}
			}

			return [start, end, viewType];
		},
		getMonday(d) {
			d = new Date(d);
			let day = d.getDay(),
				diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
			return new Date(d.setDate(diff));
		},
		getApplienceQuery(time, fieldName) {
			let query = '';
			let today = new Date();
			let start = '';
			let end = '';
			let field = '';
			let name = `${fieldName}Fields`;
			let aggregateQuery = '';

			switch (time) {
				case 'today':
					start = today.toISOString().slice(0, 10) + 'T00:00:00Z';
					today.setDate(today.getDate() + 1);
					end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
					break;
				case 'month':
					start = new Date(today.getFullYear(), today.getMonth(), 1);
					start.setDate(start.getDate() + 1);
					start = start.toISOString().slice(0, 10) + 'T00:00:00Z';
					today.setDate(today.getDate() + 1);
					end = today.toISOString().slice(0, 10) + 'T00:00:00Z';
					break;
				case 'year':
					start = new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10) + 'T00:00:00Z';
					end = new Date(today.getFullYear() + 1, 0, 2).toISOString().slice(0, 10) + 'T00:00:00Z';
					break;
			}

			for (let i = 0; i < this[name].length; i++) {
				if (i === this[name].length - 1) {
					field += `r._field == "${this[name][i]}"`;
				} else {
					field += `r._field == "${this[name][i]}" or `;
				}
			}

			switch (time) {
				case 'today':
					aggregateQuery = 'aggregateWindow(every: 1h, fn: sum, column: "_value")';
					break;
				case 'month':
					aggregateQuery = 'aggregateWindow(every: 1d, fn: sum, column: "_value")';
					break;
				case 'year':
					aggregateQuery = 'aggregateWindow(every: 1mo, fn: sum, column: "_value")';
					break;
			}

			query = `|> range(start: ${start}, stop: ${end})
             |> filter(fn:(r) => ${field})
             |> ${aggregateQuery}`;

			return query;
		}
	}
};
